module.exports = __webpack_public_path__ + "media/src/images/icons/thumb_up-c4b3755f3e9351b54326600f71784750.svg";